export default __webpack_public_path__ + "static/media/f-tuneup-img.5197ac46.gif";